// ======================================================================
// File Name       : ScoringReportModalQuestion
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../../constants';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import RenderField from '../../../utils/ReduxFormUtils';
import { blur } from 'redux-form';

class ScoringReportModalQuestion extends Component {

  constructor(props) {
    super(props);
    this.state = {
      heightOfScreen: 0,
      height: 0,
    };
    this.handleTextAreaResize = this.handleTextAreaResize.bind(this);
  }

  componentWillMount() {
    this.handleTextAreaResize();
    window.addEventListener('resize', this.handleTextAreaResize);
  }

  componentWillReceiveProps(nextProps) {
    // #7468 START
    const { detailDrill, isPartialPointUseSet } = nextProps;
    if (detailDrill && nextProps && nextProps.formValues
        && Object.keys(nextProps.formValues).length > 0 && isPartialPointUseSet) {
    // #7468 END
      const { formValues } = nextProps;
      const { partsQuestionInfo } = detailDrill;
      if (partsQuestionInfo && partsQuestionInfo.subQuestionArray && partsQuestionInfo.subQuestionArray.length > 0) {
        // case big question
        const { subQuestionArray } = partsQuestionInfo;
        for (let i = 0; i < subQuestionArray.length; i++) {
          const nameTarget = `subModifiedSankakuPoint_${i}`;
          if (formValues[`subAnswerJudgeResult_${i}`] === ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER) {
            $(`input[name='${nameTarget}']`).removeAttr('disabled');
            $(`input[name='${nameTarget}']`).val(formValues[nameTarget]);
            // #7481 START
            $(`input[name='${nameTarget}']`).removeClass("sankakuPointDisableClass");
            $(`input[name='${nameTarget}']`).addClass("sankakuPointEnableClass");
            // #7481 END
          } else {
            $(`input[name='${nameTarget}']`).attr('disabled', 'disabled');
            $(`input[name='${nameTarget}']`).val('');
            // #7481 START
            $(`input[name='${nameTarget}']`).removeClass("sankakuPointEnableClass");
            $(`input[name='${nameTarget}']`).addClass("sankakuPointDisableClass");
            // #7481 END
          }
        }
      } else {
        // case single question
        const nameTarget = 'modifiedSankakuPoint';
        if (formValues.answerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.BIG_QUESTION) {
          if (formValues.answerJudgeResult === ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER) {
            $(`input[name='${nameTarget}']`).removeAttr('disabled');
            $(`input[name='${nameTarget}']`).val(formValues[nameTarget]);
            // #7481 START
            $(`input[name='${nameTarget}']`).removeClass("sankakuPointDisableClass");
            $(`input[name='${nameTarget}']`).addClass("sankakuPointEnableClass");
            // #7481 END
          } else {
            $(`input[name='${nameTarget}']`).attr('disabled', 'disabled');
            $(`input[name='${nameTarget}']`).val('');
            // #7481 START
            $(`input[name='${nameTarget}']`).removeClass("sankakuPointEnableClass");
            $(`input[name='${nameTarget}']`).addClass("sankakuPointDisableClass");
            // #7481 END
          }
        }
      }
    }
  }

  // #5879 caculate height of screen
  handleTextAreaResize() {
    const heightOfScreen = window.innerHeight;
    const textAreaHeight = Math.round(0.7 * 0.4 * heightOfScreen);
    this.setState({ heightOfScreen, height: textAreaHeight });
  }

  render() {
    const { reportModalDialog, enableFinishSaveButton, isPartialPointUseSet, questionListOutput, isScoreFormScoreDisplay, sankakuJudgeUseSet } = this.props;
    let questionHtml = null;
    let reportComment = null;
    let classNameDisablePointer = 'padding-left-right-clear pointer';
    let classNameDisable = 'padding-left-right-clear borderSolid0pxHalf';
    if (!enableFinishSaveButton) {
      classNameDisable += ' disableDivTag';
      classNameDisablePointer += ' disablePointer';
    }
    classNameDisable += ' iframe-question';
    if (reportModalDialog) {
      const { partsQuestionInfo, reportCommentDrillQuestion } = reportModalDialog.values;
      reportComment = reportCommentDrillQuestion;
      const { answerJudgeResult } = reportModalDialog.values;
      const { point } = reportModalDialog.values;
      let isEnablePartialPoint = false; // #7427
      let isEnableSankaku = false;
      if (answerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.BIG_QUESTION) {
        // #7427 START
        isEnablePartialPoint =
          isPartialPointUseSet &&
          questionListOutput &&
          questionListOutput.sankakuUseDistinct === ReportConstants.SANKAKU_USE_DISTINCT_USE;
        isEnableSankaku =
          sankakuJudgeUseSet === ReportConstants.SANKAKU_JUDGE_USE_SET_USE &&
          questionListOutput &&
          questionListOutput.sankakuUseDistinct === ReportConstants.SANKAKU_USE_DISTINCT_USE;
        // #7427 END
        questionHtml = (
          <Col sm={12} className="form-info padding-left-right-clear">
            <Col sm={1} className="padding-left-right-clear margin-top-10">1</Col>
            <Col sm={11} className="padding-left-right-clear">
              <Col sm={2} className="padding-left-right-clear margin-top-10">
                <RenderField
                  type="radio"
                  name="answerJudgeResult"
                  value={ReportConstants.ANSWER_JUDGE_RESULT.CORRECT}
                  normalizeRadio
                  inline={false}
                />
              </Col>
              <Col sm={2} className="padding-left-right-clear margin-top-10">
                <RenderField
                  type="radio"
                  name="answerJudgeResult"
                  value={ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT}
                  normalizeRadio
                  inline={false}
                />
              </Col>
              <Col sm={2} className="padding-left-right-clear margin-top-10">
                <RenderField
                  type="radio"
                  name="answerJudgeResult"
                  value={ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER}
                  normalizeRadio
                  inline={false}
                  disabled={!isEnableSankaku}
                />
              </Col>
              <Col sm={3} className="padding-left-right-clear margin-top-10">
                {isScoreFormScoreDisplay && point ? `${point}点` : ''}
              </Col>
              {/* #7461 START */}
              <Col sm={3} className="padding-left-right-clear">
                {
                  isScoreFormScoreDisplay && point ? (
                    <RenderField
                      type="text"
                      name="modifiedSankakuPoint"
                      disabled={!isEnablePartialPoint}
                      validates={isEnablePartialPoint && (answerJudgeResult === ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER)
                        ? [VALIDATE_TYPE.NUMERIC, VALIDATE_TYPE.MAX_NUMBER]
                        : []}
                      maxNumber={point}
                      label="部分点"
                      errorClassName="sankakuPointErrorClass"
                      normalizeRadio
                    />
                  ) : ''
                }
              </Col>
              {/* #7461 END */}
            </Col>
          </Col>
        );
      } else if (partsQuestionInfo) {
        const { subQuestionArray } = partsQuestionInfo;
        if (subQuestionArray && subQuestionArray.length !== 0) {
          questionHtml = subQuestionArray.map((subQuestionItem, index) => {
            // #7427 START
            const matchedSubQuestionItem =
              questionListOutput &&
              $.grep(
                questionListOutput.subQuestionArray,
                (e) => e.subQuestionSecernId === subQuestionItem.subQuestionSecernId
              )[0];
            isEnablePartialPoint =
              isPartialPointUseSet &&
              matchedSubQuestionItem &&
              matchedSubQuestionItem.subSankakuUseDistinct === ReportConstants.SANKAKU_USE_DISTINCT_USE;

            isEnableSankaku = sankakuJudgeUseSet === ReportConstants.SANKAKU_JUDGE_USE_SET_USE &&
              matchedSubQuestionItem &&
              matchedSubQuestionItem.subSankakuUseDistinct === ReportConstants.SANKAKU_USE_DISTINCT_USE;
            // #7427 END
            return (
              <Col sm={12} key={index} className="form-info padding-left-right-clear margin-bottom-10">
                <Col sm={1} className="padding-left-right-clear margin-top-10">{index + 1}</Col>
                <Col sm={11} className="padding-left-right-clear">
                  <Col sm={2} className="padding-left-right-clear margin-top-10">
                    <RenderField
                      type="radio"
                      name={`subAnswerJudgeResult_${index}`}
                      value={ReportConstants.ANSWER_JUDGE_RESULT.CORRECT}
                      normalizeRadio
                      inline={false}
                    />
                  </Col>
                  <Col sm={2} className="padding-left-right-clear margin-top-10">
                    <RenderField
                      type="radio"
                      name={`subAnswerJudgeResult_${index}`}
                      value={ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT}
                      normalizeRadio
                      inline={false}
                    />
                  </Col>
                  <Col sm={2} className="padding-left-right-clear margin-top-10">
                    <RenderField
                      type="radio"
                      name={`subAnswerJudgeResult_${index}`}
                      value={ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER}
                      normalizeRadio
                      inline={false}
                      disabled={!isEnableSankaku}
                    />
                  </Col>
                  <Col sm={3} className="padding-left-right-clear margin-top-10">
                    {isScoreFormScoreDisplay && subQuestionItem.subPoint ? `${subQuestionItem.subPoint}点` : ''}
                  </Col>
                  {/* #7461 START */}
                  <Col sm={3} className="padding-left-right-clear">
                    {
                      isScoreFormScoreDisplay && subQuestionItem.subPoint ? (
                        <RenderField
                          type="text"
                          name={`subModifiedSankakuPoint_${index}`}
                          disabled={!isEnablePartialPoint}
                          validates={isEnablePartialPoint && reportModalDialog.values[`subAnswerJudgeResult_${index}`] === ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER
                            ? [VALIDATE_TYPE.NUMERIC, VALIDATE_TYPE.MAX_NUMBER]
                            : []}
                          maxNumber={subQuestionItem.subPoint}
                          label="部分点"
                          errorClassName="sankakuPointErrorClass"
                          normalizeRadio
                        />
                      ) : ''
                    }
                  </Col>
                  {/* #7461 END */}
                </Col>
              </Col>
            );
          });
        }
      }
    }
    return (
      <div>
        <Col sm={12} className={classNameDisable}>
          <Col sm={12} className="form-info text-center margin-top-10">
            採点欄
          </Col>
          <Col sm={12} className="form-info padding-left-right-clear margin-top-10">
            <Col sm={8} className="padding-left-right-clear" style={{ width: '60%' }}>
              <Col as={Form.Label} sm={{ span: 11, offset: 1 }} className="padding-left-right-clear">
                <Col sm={2} className="padding-left-right-clear">
                  o
                </Col>
                <Col sm={2} className="padding-left-right-clear">
                  x
                </Col>
                <Col sm={2} className="padding-left-right-clear">
                  △
                </Col>
                <Col sm={3} className="padding-left-right-clear">
                  配点
                </Col>
                <Col sm={3} className="padding-left-right-clear">
                  部分点
                </Col>
              </Col>
            </Col>
            <Col
              sm={4}
              as={Form.Label}
              className="padding-left-right-clear text-center"
              style={{ width: '40%' }}
            >
              添削用コメント
            </Col>
          </Col>
          <Col sm={12} className="form-info padding-left-right-clear margin-top-10 margin-bottom-10">
            <Col sm={8} className={classNameDisablePointer} style={{ width: '60%' }}>
              {questionHtml}
            </Col>
            <Col
              sm={4}
              as={Form.Label}
              className='padding-right-15'
              style={{ pointerEvents: 'auto', width: '40%' }}
            >
              <RenderField
                type="textarea"
                name="reportCommentDrillQuestion"
                value={reportComment}
                className="textColorRed"
                readOnly={!enableFinishSaveButton}
                maxLength={2048}
                height={this.state.height}
              />
            </Col>
          </Col>
        </Col>
      </div>
    );
  }
}

export default ScoringReportModalQuestion;
